import React from 'react'
import { SvgIconProps } from './Home'

const SvgRadioCheckedIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="68"
    height="19"
    fill="none"
    viewBox="0 0 68 19"
  >
    <rect
      width="17"
      height="17"
      x="0.5"
      y="0.5"
      fill="#fff"
      stroke="#C7C7C7"
      rx="8.5"
    ></rect>
    <rect width="10" height="10" x="4" y="4" fill={fill ?? "#95358F"} rx="5"></rect>
  </svg>
)


export default SvgRadioCheckedIcon